<template>
    <v-flex>      
        <search-asset
           type="favorite_search"
          :includeFavoritesUserId="userId"
          @AssetSelected="assetSelected"
        >
        </search-asset>    
        <asset-user-favorite v-if="favoritePannelOpen"
            :favorite="selectedFavorite" 
            :userId="userId"       
            :assetId="selectedAssetId" 
            @favoriteSaved="favoriteSaved()"
            @panelClosed="closeFavoritePanel">
        </asset-user-favorite>           
    </v-flex>
</template>

<script>
import * as types from '../../store/types'
import { mapGetters } from 'vuex'
import ColorMixin from '../../plugins/mixins/ColorMixin'
import AssetUserFavorite from './AssetUserFavorite'
import SearchAsset from './SearchAsset.vue'

export default {
    components: {
        AssetUserFavorite,
        SearchAsset
    }, 
    props: {
        assetId:null,
        userId: {},
    },
    data() {
        return {         
            selectedFavorite:null,
            selectedAssetId:null,
            favoritePannelOpen:false,
        }
    },  
    methods: {
      assetSelected(asset){
             
        let fav = this.isFavorite(asset)
        if(fav){
            this.selectedFavorite = fav        
        }

        this.selectedAssetId = asset.id        
        this.favoritePannelOpen = true
      },
      favoriteSaved(){
        this.closeFavoritePanel()
      },
      isFavorite(asset){
        if(!asset.userFavorites){
            return false
        }
        else{
            let vm = this
            let res =  asset.userFavorites.find((favorite) => { return favorite.userId == vm.userId }) 

            return res ? res : false
        }            
      },      
      closeFavoritePanel(){
        this.selectedFavorite=null
        this.selectedAssetId=null
    
        this.favoritePannelOpen = false
      }
    },
    mounted(){

      console.log("AddUserFavorite -> ",this.userId)

    }
}
</script>

<style lang="scss" scoped>

</style>